import React from 'react';
import { MapPin, Navigation } from 'lucide-react';

const MapSection = ({ 
  className = "",
  title = "Find Us Here",
  // subtitle = "Visit our office in the heart of Kozhikode"
}) => {
  const mapData = {
    address: {
      company: "Whitespace Properties LLP",
      full: "5th Floor, Elite Arcade, Kannur Road, Chakkorthkulam, Kozhikode, Kerala 673003"
    },
    // Google Maps embed URL - replace with your actual embed URL
    embedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3204.6318046914007!2d75.76982127398824!3d11.27540374979395!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba65ece1935354b%3A0x191966ca3640e754!2sElite%20Arcade!5e1!3m2!1sen!2sin!4v1759225907680!5m2!1sen!2sin"
  };

  const handleDirectionsClick = () => {
    window.open(
      `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(mapData.address.full)}`,
      '_blank'
    );
  };

  return (
    <div className={`bg-white rounded-2xl max-w-6xl mx-auto overflow-hidden border border-gray-100 ${className}`}>
      {/* Header */}
      <div className="p-3 sm:p-6 bg-gray-50 border-b border-gray-200">
        <div className="flex flex-wrap gap-5 items-center justify-between">
          <div>
            <h3 className="text-xl font-medium text-gray-900 flex items-center gap-3">
              <MapPin className="w-5 h-5 text-[var(--primarycolor)]" />
              {title}
            </h3>
            {/* <p className="text-gray-600 mt-1">{subtitle}</p> */}
          </div>
          
          <button
            onClick={handleDirectionsClick}
            className="flex items-center gap-2 bg-[var(--primarycolor)] hover:bg-red-800 text-white px-4 py-2 rounded-lg font-medium transition-all duration-300 text-sm group"
          >
            <Navigation className="w-4 h-4 group-hover:rotate-12 transition-transform duration-300" />
            Get Directions
          </button>
        </div>
      </div>
      
      {/* Embedded Google Map */}
      <div className="h-80">
        <iframe
          src={mapData.embedUrl}
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Whitespace Properties Office Location - Elite Arcade, Kozhikode"
          className="w-full h-full"
        ></iframe>
      </div>

      {/* Footer with Address and Directions */}
      {/* <div className="p-6 bg-white">
        <div className="flex items-start justify-between">
          <div className="flex-1">
            <h4 className="font-semibold text-gray-900 mb-2">Office Address</h4>
            <address className="text-gray-600 not-italic text-sm leading-relaxed">
              {mapData.address.full}
            </address>
          </div>
          
          <div className="ml-4">
            <button
              onClick={handleDirectionsClick}
              className="text-red-600 hover:text-red-700 font-medium text-sm transition-colors duration-300 flex items-center gap-1"
            >
              Navigate
              <Navigation className="w-3 h-3" />
            </button>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default MapSection;